<template>
    <div class="login-container">
      <nav-bar :showBack="false"/>
      <van-form @submit="onSubmit">
        <div class="page-title"> {{$t('密码重置')}} </div>
        <div class="page-tip"> {{ $t('请输入注册的邮箱地址或手机号码') }} </div>

        <drop-down-view :verify-type="verifyType" @onTypeClick="onTypeClick"/>

        <van-field v-show="verifyType == VerifyType.SMS" v-model="user.mobile" class="custom-field" :placeholder="$t('请输入手机号码')" type="number" clearable>
        <template #left-icon>
          <div class="area-code" @click="onAreaCodeClick">
            {{ mobilePrefix }}
            <van-icon name="arrow-down" />
          </div>
        </template>
        </van-field>

        <van-field v-show="verifyType == VerifyType.EMAIL" class="custom-field" v-model="user.email" :placeholder="$t('请输入注册邮箱地址')" type="text" clearable>
        </van-field>

        <van-field v-show="isCaptcha" v-model="user.captcha" class="custom-field" :placeholder="$t('请输入图片验证码')" clearable>
            <template #button>
            <img :src="captchaSrc" class="captchaImg" @click="getCrateCaptchaSub">
            </template>
        </van-field>

      <van-field v-model="user.code" class="custom-field" :placeholder="verifyCodePlaceholderText(verifyType)" type="number" clearable>
        <template #button>
          <van-count-down v-show="isCountDownShow" ref="countDown" millisecond :time="1000*60" :auto-start="false" format="ss" @finish="finish">
            <template #default="timeData">
                <span class="countDownBlock">{{ $t('重新发送')+ '(' +timeData.seconds + 's)'}}</span>
            </template>
          </van-count-down>
          <span v-show="!isCountDownShow" class="send-sms-btn" @click="onSendMailCode"> {{$t('获取验证码')}} </span>
        </template>
      </van-field>

        <van-button class="login-btn" :disabled="(verifyType == VerifyType.EMAIL ?  !user.email : !user.mobile) || !user.code || (isCaptcha&&!user.captcha)" block type="info" native-type="submit" @touchstart="onFailed()">
          {{ $t('下一步') }}
        </van-button>

      </van-form>

      <mobile-prefix-popup-view v-model="areaPopupShow" :region="region" @onRegionClick="onRegionClick"/>
      <verify-type-popup-view v-model="verifyTypeShow" :type="verifyType" @onTypeClick="onVerifyPopupSelect"/>
      <tip-popup-view v-model="tipShow" :tip-content="tipContent" :button-content="tipButton"/>
    </div>
  </template>
<script>

import { Encrypt } from '@/utils/crypto.js'

import { Icon, Form, Field, Button, CheckboxGroup, Checkbox, CountDown, Toast, Popup, Dialog } from 'vant'
import { sendResetPwdCode, verifyCodeForResetPwd } from '@/api/common/index'
import NavBar from '@/components/NavBar'
import TipPopupView from '@/components/TipPopupView'
import PageBase from '@/mixin/page-base'
import DropDownView from '@/components/DropDownView'
import { VerifyType } from '@/config/entrance.js'
import VerifyTypePopupView from '@/components/VerifyTypePopupView'
import { mapGetters } from 'vuex'
import MobilePrefixPopupView from '@/components/MobilePrefixPopupView'

export default {
  mixins: [PageBase],
  components: {
    VerifyTypePopupView,
    MobilePrefixPopupView,
    DropDownView,
    NavBar,
    TipPopupView,
    [Icon.name]: Icon,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [CountDown.name]: CountDown,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog
  },
  props: {},
  data () {
    return {
      VerifyType,
      user: {
        mobile: '',
        email: '',
        captcha: '',
        code: ''
      },
      verifyType: VerifyType.SMS,
      verifyTypeShow: false,
      isCountDownShow: false,
      isCaptcha: false,
      captchaSrc: '',
      areaPopupShow: false
    }
  },
  computed: {
    ...mapGetters(['mobilePrefixList']),
    mobilePrefix() {
      const item = this.mobilePrefixList.filter(item => item.B === this.mobileRegion)[0]
      return item ? item.N : '+60'
    }
  },
  watch: {},
  created () {
  },
  mounted () {
    this.initParamter()
  },
  methods: {

    onRegionClick(item){
      this.mobileRegion = item.B
    },

    onAreaCodeClick(){
      this.tryToRequestAreaConfigInfo().then(() => {
        this.$router.push({ path: '/mobile-prefix-list', query: this.$route.query })
      }).catch((error) => {
        this.showTipPopup(error, this.$t('确定'))
      })
    },

    verifyCodePlaceholderText(type){
      return type === VerifyType.EMAIL ? this.$t('请输入邮箱验证码') : this.$t('请输入验证码')
    },

    onVerifyPopupSelect(type){
      if (this.verifyType !== type) {
        this.verifyType = type
        this.user.mobile = ''
        this.user.email = ''
        this.user.code = ''
        this.user.captcha = ''
        this.isCountDownShow = false
        this.isCaptcha = false
      }
    },

    onTypeClick(){
      this.verifyTypeShow = true
    },

    onSubmit () {
      if (this.verifyType === VerifyType.EMAIL && !this.isValidEmail(this.user.email)) {
        Toast(this.$t('邮箱格式错误'))
        return
      }

      this.showLoading()
      let data = {}
      if (this.verifyType === VerifyType.EMAIL) {
        data.account = Encrypt(this.user.email)
        data.verifyCode = this.user.code
      } else {
        data.account = Encrypt(this.user.mobile)
        data.verifyCode = this.user.code
        data.areaCode = this.mobilePrefix
      }

      verifyCodeForResetPwd(data).then(res => {
        this.dismissLoading()
        if (res.code === 100) {
          this.goPwdResetPage()
        } else {
          this.showTipPopup(res.desc, this.$t('确定'))
        }
      }).catch((error) => {
        this.dismissLoading()
        this.showTipPopup(error, this.$t('确定'))
      })
    },

    goPwdResetPage(){
      let data = {}
      if (this.verifyType === VerifyType.EMAIL) {
        data.email = Encrypt(this.user.email)
      } else {
        data.mobile = Encrypt(this.user.mobile)
        data.areaCode = this.mobilePrefix
      }
      data.verifyCode = this.user.code
      this.$store.dispatch('user/setResetPwdParam', data).then(() => {
        this.$router.push({ path: '/forget-pwd-verify', query: this.$route.query })
      })
    },

    // 根据类型选择发送验证码
    onSendMailCode () {
      if (this.isCaptcha && !this.user.captcha) {
        Toast(this.$t('请输入图片验证码'))
        return
      }

      if (this.verifyType === VerifyType.EMAIL) {
        if (!this.user.email) {
          Toast(this.$t('请输入注册邮箱地址'))
          return
        }

        if (!this.isValidEmail(this.user.email)) {
          Toast(this.$t('邮箱格式错误'))
          return
        }
      }

      if (this.verifyType === VerifyType.SMS && !this.user.mobile) {
        Toast(this.$t('请输入手机号码'))
        return
      }

      let data = {}
      if (this.verifyType === VerifyType.EMAIL) {
        data.email = Encrypt(this.user.email)
      } else {
        data.mobile = Encrypt(this.user.mobile)
        data.areaCode = this.mobilePrefix
      }

      if (this.isCaptcha) {
        data.captcha = this.user.captcha
      }

      this.showLoading(this.$t('获取验证码...'))
      sendResetPwdCode(data).then(res => {
        this.dismissLoading()
        if (res.code === 100) {
          if (!res.mobBaseRes.result) {
            this.getCrateCaptchaSub()
          } else {
            Toast(this.$t('验证码已发送'))
            this.isCountDownShow = true
            this.$refs.countDown.reset()
            this.$refs.countDown.start()
          }
        } else {
          this.showTipPopup(res.desc, this.$t('确定'))
        }
      }).catch((error) => {
        this.dismissLoading()
        this.showTipPopup(error, this.$t('确定'))
      })
    },

    getCrateCaptchaSub () {
      const identifier = this.verifyType === VerifyType.EMAIL ? this.user.email : this.user.mobile
      this.getCrateCaptcha({ identifier: Encrypt(identifier) })
    },

    finish () {
      this.isCountDownShow = false
    }

  }
}
</script>
  <style scoped lang="less">
  .login-container {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    padding: 0px 24px;
    .viomi-logo {
      width: 59px;
      height: 52px;
      margin-top: 28px;
      align-self: center;
    }
    .page-title {
      margin-bottom: 28px;
      font-size: 24px;
      font-weight: 500;
      color: #2C2C2C;
      align-self: center;
      text-align: center;
    }
    .page-tip {
        font-size: 12px;
        color: #999;
        margin-top:18px;
    }
    .password-tip {
        font-size: 12px;
        color: #999999;
        margin-top: 12px;
    }
    .custom-field {
    background-color: #F5F7FA;
    margin-top: 8px;
    border-radius: 8px;
    font-size: 14px;
    .area-code {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 65px; /* 增加宽度 */
      height: 40px;
    }
    .captchaImg {
      width: 104px;
      height: 36px;
    }
  }
  .custom-field /deep/ .van-field__button {
      display: flex;
      align-items: center;
    }

  .custom-field /deep/ .van-field__control {
    border-bottom: none;
    height: 40px;
  }
    .forget-pwd {
      font-size: 12px;
      font-weight: 400;
      color: gray;
      align-self: flex-end;
      text-align: right;
      margin-top: 16px;
    }

    .input-desc {
      font-size: 10px;
      color: #999999;
      line-height: 20px;
      position: relative;
      opacity: 0;
    }
    .inputDescAct {
      opacity: 1;
      animation: myfirst 0.05s;
      -webkit-animation: myfirst 1s; /* Safari and Chrome */
    }
    @keyframes myfirst {
      0% {
        opacity: 0;
        left: 0px;
        top: 5px;
      }
      100% {
        opacity: 1;
        left: 0px;
        top: 0px;
      }
    }

    @-webkit-keyframes myfirst /* Safari and Chrome */ {
      0% {
        opacity: 0;
        left: 0px;
        top: 5px;
      }
      100% {
        opacity: 1;
        left: 0px;
        top: 0px;
      }
    }
    .send-sms-btn {
      height: 16px;
      line-height: 16px;
      font-size: 13px;
      color: #28beca;
    }
    .login-btn {
      margin-top: 16px;
      background: linear-gradient(90deg, #5fd1db 0%, #28beca 100%);
      border: none;
      border-radius: 8px;
      height: 48px;
      font-size: 14px;
      width:327px;
    }
    .countDownBlock {
      color: #ace6ebff;
      font-size: 13px;
    }
    .iframeBody {
      width: 100%;
      height: 100%;
    }
  }
  </style>
